import { TextField } from "@mui/material";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, purpleMui } from "@ryde/theme";

export const FreeTextFieldWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "free-text-field-wrapper",
})`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding-block: 3px;
  padding-inline: 7px;
  border: 1px solid ${greyMui._300};
  border-radius: 4px;
  color: ${blueGreyMui._400};
  cursor: pointer;
  svg.circle-x-mark {
    color: ${blueGreyMui.A200};
  }

  &:hover {
    border-color: ${purpleMui._500};
  }
`;

export const FreeTextFieldLabel = styled.label.attrs<IStyledAttributes>({
  "data-e2e": "free-text-field-label",
})`
  display: flex;
  align-items: center;
  cursor: inherit;
`;

export const FreeTextFieldInputStyled = styled(TextField)`
  & .MuiOutlinedInput-input {
    padding: 0;
    height: 26px;
    width: 80px;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiInputBase-adornedEnd {
    padding-inline-start: 0;
  }

  & .MuiInputAdornment-root {
    margin-block-start: 2px;
  }
`;
